module.exports = __webpack_public_path__ + "img/barraFondoMobile.c140fab8.svg";